import { saludoDeLaHora } from '@/lib/utils/saludo-de-la-hora';

/** El saludo vive en `lib/utils/saludo-de-la-hora.ts` (uno solo para todas las pantallas). */
export { saludoDeLaHora };

/** El primer nombre, para el saludo: «Roberto Méndez» → «Roberto». */
export function primerNombre(nombre: string | null | undefined): string | null {
  const limpio = (nombre ?? '').trim();
  if (!limpio) return null;
  return limpio.split(/\s+/)[0];
}

/**
 * El saludo de la maqueta: el nombre con el degradado de Prixia. Sin nombre,
 * sólo el saludo (nunca «Buenos días, .»).
 */
export function Saludo({ nombre, fecha }: { nombre?: string | null; fecha?: Date }) {
  const quien = primerNombre(nombre);
  const saludo = saludoDeLaHora(fecha);
  if (!quien) return <>{saludo}.</>;
  return (
    <>
      {saludo}, <span className="text-primary">{quien}</span>.
    </>
  );
}
